import { useContext } from "react";
import { Tooltip } from "@mantine/core";
import { prettifyPropertyName } from "../../../../../../common/prettifyPropertyName";
import { AppInfoContext } from "../../../../../../components/contexts/AppInfoContext";
import { BehaviorParameter } from "../../../../../../types/behaviors";
import { WithRequiredProperty } from "../../../../../../types/common";

interface IInputTooltip {
	children: JSX.Element | JSX.Element[];
	disabled: boolean;
	elementOnWhichInputDepends?: WithRequiredProperty<BehaviorParameter, "property">;
}

const InputTooltip: React.FC<IInputTooltip> = ({ disabled, elementOnWhichInputDepends, children }) => {
	const { isSuperuser } = useContext(AppInfoContext);

	return (
		<Tooltip
			label={
				isSuperuser
					? `This input is disabled because it depends on ${
							(elementOnWhichInputDepends && prettifyPropertyName(elementOnWhichInputDepends.property)) || "another input"
						}`
					: "You don't have rights to modify this setting"
			}
			disabled={disabled}
		>
			{children}
		</Tooltip>
	);
};

export default InputTooltip;
